import { render, staticRenderFns } from "./QueryHistory.vue?vue&type=template&id=f2904d9a&scoped=true&"
import script from "./QueryHistory.vue?vue&type=script&lang=js&"
export * from "./QueryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2904d9a",
  null
  
)

export default component.exports